export default __webpack_public_path__ + "static/feature-l3-image-b6983969b26258e3f2aaaf7e8c7dfcce.png";